import { Button, Text, mergeClasses } from "@fluentui/react-components";
import { app } from "@microsoft/teams-js";
import { mainAppUrl } from "../services/graphService";
import { useUiStyles, IconTile, RocketIcon } from "./ui";
import { useLanguage } from "../i18n/LanguageContext";

/**
 * Hand-off card: invites the user to unlock the full Meeting Angelo platform.
 * Clean white card with a brand accent line (no gradient) — matches the rest
 * of the app's minimal Fluent look.
 */
export function UpgradeCta({ insideTeams }: { insideTeams: boolean }) {
  const s = useUiStyles();
  const { t } = useLanguage();

  const openFullApp = async () => {
    if (insideTeams) {
      try {
        await app.openLink(mainAppUrl);
        return;
      } catch {
        // Fall through to a standard navigation if the deep link fails.
      }
    }
    window.open(mainAppUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className={mergeClasses(s.card, s.accentTop)} style={{ padding: "18px 18px 20px" }}>
      <div className={s.row}>
        <IconTile variant="brand">
          <RocketIcon />
        </IconTile>
        <div className={s.grow}>
          <Text size={400} weight="semibold" block>
            {t("upgrade.title")}
          </Text>
          <Text block style={{ margin: "4px 0 14px", color: "var(--colorNeutralForeground2)" }}>
            {t("upgrade.body")}
          </Text>
          <Button appearance="primary" onClick={openFullApp}>
            {t("upgrade.cta")}
          </Button>
        </div>
      </div>
    </div>
  );
}
